
const eventTypes = ['change', 'change:layerGroup', 'change:size', 'change:target', 'change:view',
'click', 'dblclick', 'moveend', 'movestart',
'pointerdrag', 'pointermove', 'postcompose', 'postrender', 'precompose',
'propertychange', 'rendercomplete', 'singleclick'];

/**
 * Updates event listeners for an openlayers object. 
 * 
 * @param {*} prevProps previous properties of the react component.
 * @param {*} currentProps current properties of the react component.
 * @param {*} eventTypes the event types that should be verified in prevProps and currentProps.
 * @param {*} olObject the open layers object of which event listeners should be updated.
 */
function updateOLObjectEventListeners(prevProps, currentProps, olObject) {
    let eventTypesToUpdate;

    if (!isNullOrUndefined(prevProps)) {
        eventTypesToUpdate = eventTypes
            .filter(eventType => prevProps[eventType] !== currentProps[eventType]);

        eventTypesToUpdate
            .filter(eventTypeToUpdate => !isNullOrUndefined(prevProps[eventTypeToUpdate]))
            .forEach(eventTypeToUpdate => {
                olObject.un(eventTypeToUpdate, prevProps[eventTypeToUpdate]);
            })
    }
    else {
        eventTypesToUpdate = eventTypes;
    }

    eventTypesToUpdate
        .filter(eventTypeToUpdate => !isNullOrUndefined(currentProps[eventTypeToUpdate]))
        .forEach(eventTypeToUpdate => {
            olObject.on(eventTypeToUpdate, currentProps[eventTypeToUpdate]);
        })
}

function isNullOrUndefined(object) {
    return typeof object === 'undefined' || object === null;
}

/**
 * Returns value if it's not null or undefined, else returns defaultValue.
 * @param {*} value the value to be returned if it's not null or undefined.
 * @param {*} defaultValue the defaultValue to be returned if value is null or undefined.
 */
function valueOrDefault(value, defaultValue) {
    return !isNullOrUndefined(value) ? value : defaultValue;
}

function arraysShalowEqual(array1, array2) {
    if(array1 === array2){
        return true;
    }
    if(isNullOrUndefined(array1) || isNullOrUndefined(array2)){
        return false;
    }
    if(array1.length !== array2.length){
        return false;
    }
    return array1.every((value, index) => value === array2[index]);
}

const encodeURIParameters = (uri, parameters) => {
	if(!parameters){
		return uri;
	}
	
	const encodedParameters = Object.keys(parameters).map(parameter => {
		const valueOrArray = parameters[parameter];
		if(Array.isArray(valueOrArray)){
			return valueOrArray
				.map(value => encode(parameter, value))
				.filter(exists)
				.join('&');
		}
		
		return encode(parameter, valueOrArray);
	}).filter(exists).join('&');
	
	if(encodedParameters.length === 0){
		return uri;
	}
	
	return uri + '?' + encodedParameters;
	
	function encode(parameter, value){
		if(!exists(parameter) || !exists(value)){
			return undefined;
		}
		return encodeURIComponent(parameter) + '=' + encodeURIComponent(value);
	}
	
	function exists(value){
		return value !== undefined && value !== null;
	}
}

export { arraysShalowEqual, updateOLObjectEventListeners, isNullOrUndefined, valueOrDefault, encodeURIParameters };
